module.exports = __webpack_public_path__ + "static/brain-22fd021b0357bfd697dadfcc414e25de.svg";